import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDown, Code, TrainFront } from 'lucide-react';
import { Button } from "@/components/ui/button";
import heroBg from '../../assets/hero-cockpit.webp';

const Hero = () => {
  return (
    <section className="relative h-screen w-full flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src={heroBg}
          alt="Train Cockpit"
          className="w-full h-full object-cover opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background/80 via-background/60 to-background" />
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')] opacity-10 mix-blend-overlay"></div>
      </div>

      {/* Content */}
      <div className="container relative z-10 px-4 flex flex-col items-center text-center">

        {/* Badges */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="flex flex-wrap gap-4 justify-center mb-6"
        >
          <div className="flex items-center gap-2 px-4 py-1 bg-secondary/50 border border-secondary backdrop-blur-sm rounded-full text-sm font-mono text-secondary-foreground">
            <Code className="w-4 h-4" />
            <span>INDIE DEV</span>
          </div>
          <div className="flex items-center gap-2 px-4 py-1 bg-primary/20 border border-primary/50 backdrop-blur-sm rounded-full text-sm font-mono text-primary">
            <TrainFront className="w-4 h-4" />
            <span>LOKRANGIERFÜHRER</span>
          </div>
        </motion.div>

        {/* Main Title */}
        <motion.h1
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.7, delay: 0.2 }}
          className="text-6xl md:text-8xl lg:text-9xl font-display font-bold tracking-tighter text-white mb-6 uppercase"
          style={{ textShadow: "0 0 40px rgba(0,0,0,0.5)" }}
        >
          CODE & <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-red-600">STEEL</span>
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.4 }}
          className="max-w-2xl text-lg md:text-xl text-muted-foreground mb-10 font-light"
        >
          Willkommen auf <span className="text-foreground font-semibold">xearox.de</span>.
          Hier treffen digitale Welten auf tonnenschwere Realität.
          Vom Lokführerstand ins Home Office.
        </motion.p>

        {/* CTA Buttons */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.6 }}
          className="flex flex-col sm:flex-row gap-4"
        >
          <Button size="lg" className="bg-primary hover:bg-red-700 text-white font-mono text-lg px-8 rounded-sm shadow-[0_0_20px_rgba(220,38,38,0.3)]">
            MEINE PROJEKTE ANSEHEN
          </Button>
          <Button size="lg" variant="outline" className="border-secondary hover:bg-secondary/20 text-foreground font-mono text-lg px-8 rounded-sm">
            ÜBER MICH
          </Button>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1, duration: 1 }}
        className="absolute bottom-10 left-1/2 -translate-x-1/2 animate-bounce text-muted-foreground"
      >
        <ArrowDown className="w-6 h-6" />
      </motion.div>

      {/* Decorative Lines */}
      <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-primary to-transparent opacity-50"></div>
    </section>
  );
};

export default Hero;
